import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../hooks/redux'
import {
    identifier,
    trashData,
    setIdentified,
    setTrashed,
    setStep,
    setSuccess as setProfileTrashDataSuccess,
    setError as setProfileTrashDataError,
    setErrorMessage as setProfileTrashDataErrorMessage
} from '../../../../../store/reducers/ProfileTrashDataSlice'
import {
    setResponseSuccess,
    setResponseSuccessShow,
    //setResponseWarning,
    //setResponseWarningShow,
    setResponseErrorShow,
    setResponseError
} from '../../../../../store/reducers/app/ResponseInfoSlices'
import { setAlert } from '../../../../../store/reducers/app/CustomAlertSlice'
import {
    SetPhoneInitialValues,
    SetPhoneOnsubmit,
    SetPhoneValidate
} from '../../../../../FormTypes/FSetPhone'
import {
    SetCodeInitialValues,
    SetCodeOnsubmit,
    SetCodeValidate
} from '../../../../../FormTypes/FSetCode'
import { FormikErrors, FormikHelpers } from 'formik'
import { RoutesPath } from '../../../../../constants/RoutesPath'
import { Strings } from '../../../../../constants/Strings'
import { Colors } from '../../../../../constants/Colors'
import style from '../../../../../rootStyles/Content.module.css'
import Header from '../../../../../components/Header/Header'
import Info from '../../../../../components/Info/Info'
import SendPhoneForm from '../../../../../components/forms/SendPhoneForm'
import SendCodeForm from '../../../../../components/forms/SendCodeForm'
import PrevNextChanger from '../../../../../components/widgets/PrevNextChanger/PrevNextChanger'


const Trash = () => {

    const dispatch = useAppDispatch()

    const theme = useAppSelector<string>(state => state.theme.theme)
    const language = useAppSelector<string>(state => state.language.language)

    const identified = useAppSelector<boolean>(state => state.profileTrashData.identified)
    const trashed = useAppSelector<boolean>(state => state.profileTrashData.trashed)

    const step = useAppSelector<number>(state => state.profileTrashData.step)

    const profileTrashDataSuccess = useAppSelector<number | null>(state => state.profileTrashData.success)
    const profileTrashDataError = useAppSelector<number | null>(state => state.profileTrashData.error)
    const profileTrashDataErrorMessage = useAppSelector<string | null>(state => state.profileTrashData.errorMessage)

    const onChangeStep = (step: number) => {
        dispatch(setStep(step))
    }

    useEffect(() => {
        if (identified) {
            onChangeStep(2)
        }
    }, [identified])

    useEffect(() => {
        if (trashed) {
            dispatch(setIdentified(false))
            dispatch(setTrashed(false))
            onChangeStep(1)
        }
    }, [trashed])

    // SEND PHONE
    const identifierInitialValues: SetPhoneInitialValues = {
        code: '',
        phone: ''
    }

    const identifierValidate: SetPhoneValidate = (values: SetPhoneInitialValues) => {
        let errors: FormikErrors<SetPhoneInitialValues> = {}
        
        if (!values.phone) {
            errors.phone = Strings[language ?? 'tm'].required
        } else if (values.phone.length < 8) {
            errors.phone = Strings[language ?? 'tm'].min + ': 8/' + values.phone.length
        } else if (values.phone.length > 10) {
            errors.phone = Strings[language ?? 'tm'].max + ': 10/' + values.phone.length
        } else if (!/^[0-9]{8,10}$/i.test(values.phone)) {
            errors.phone = Strings[language ?? 'tm'].error + '. ' + Strings[language ?? 'tm'].pattern + ': ' + Strings[language ?? 'tm'].numbers + ' (0-9).'
        }
        return errors
    }

    const identifierPhoneOnSubmit: SetPhoneOnsubmit = (values: SetPhoneInitialValues, actions: FormikHelpers<SetPhoneInitialValues>) => {
        const phone = (values.code ? values.code : '+993') + ' ' + values.phone
        dispatch(identifier({
            phone: phone
        }))
        actions.setSubmitting(false);
    }

    // SEND CODE
    const trashDataInitialValues: SetCodeInitialValues = {
        code: ''
    }

    const trashDataValidate: SetCodeValidate = (values: SetCodeInitialValues) => {
        let errors: FormikErrors<SetCodeInitialValues> = {}
        
        if (!values.code) {
            errors.code = Strings[language ?? 'tm'].required
        } else if (values.code.length < 6) {
            errors.code = Strings[language ?? 'tm'].min + ': 6/' + values.code.length
        } else if (values.code.length > 6) {
            errors.code = Strings[language ?? 'tm'].max + ': 6/' + values.code.length
        } else if (!/^[0-9]{6,6}$/i.test(values.code)) {
            errors.code = Strings[language ?? 'tm'].error + '. ' + Strings[language ?? 'tm'].pattern + ': ' + Strings[language ?? 'tm'].numbers + ' (0-9).'
        }
        return errors
    }

    const trashDataOnSubmit: SetCodeOnsubmit = (values: SetCodeInitialValues, actions: FormikHelpers<SetCodeInitialValues>) => {
        const code = parseInt(values.code)
        dispatch(trashData({
            code: code
        }))
        actions.setSubmitting(false);
    }

    // ERRORS
    useEffect(() => {
        if (profileTrashDataSuccess) {
            dispatch(setResponseSuccess(profileTrashDataSuccess))
            dispatch(setResponseSuccessShow(true))
            dispatch(setProfileTrashDataSuccess(null))
        }
    }, [profileTrashDataSuccess])
    
    useEffect(() => {
        if (profileTrashDataError) {
            dispatch(setResponseError(profileTrashDataError))
            dispatch(setResponseErrorShow(true))
            dispatch(setProfileTrashDataError(null))
        }
    }, [profileTrashDataError])

    useEffect(() => {
        if (profileTrashDataErrorMessage) {
            dispatch(setAlert({
                title: (
                    Strings[language ?? 'tm'].profileDataPage + "!"
                ),
                description: (
                    Strings[language ?? 'tm'].profileTrash + " | "
                    + Strings[language ?? 'tm'].error + ": "
                    + profileTrashDataErrorMessage
                ),
                functions: [],
                sound: 0
            }))
            dispatch(setProfileTrashDataErrorMessage(null))
        }
    }, [profileTrashDataErrorMessage])

    return (
        <div
            className={style.container}
            style={{
                backgroundColor: Colors[theme ?? 'light'].background
            }}
        >
            <Header
                leftIcon={"fas fa-chevron-left"}
                leftPath={RoutesPath.privacyPolicy}
                leftClick={null}
                title={Strings[language ?? 'tm'].profileTrash}
                rightIcon={null}
                rightPath={null}
                rightClick={null}
            />
            <div
                className={style.content}
                style={{
                    backgroundColor: Colors[theme ?? 'light'].secondBackground
                }}
            >
                <Info
                    icon={'fas fa-circle-info'}
                    info={Strings[language ?? 'tm'].trashProfileTitle}
                    requestI={Strings[language ?? 'tm'].trashProfileI}
                />
                
                {step === 1 && <>
                    <div
                        className={style.smallFormContainer}
                    >
                        <div
                            className={style.titleContainer}
                        >
                            <h1
                                className={style.title}
                                style={{
                                    color: Colors[theme ?? 'light'].text
                                }}
                            >
                                <i className={"fas fa-phone"}></i> {Strings[language ?? 'tm'].phone}
                            </h1>
                        </div>
                        <div
                            className={style.form}
                        >
                            <SendPhoneForm
                                initialValues={identifierInitialValues}
                                validate={identifierValidate}
                                onSubmit={identifierPhoneOnSubmit}
                            />
                        </div>
                    </div>
                    <PrevNextChanger
                        title={Strings[language ?? 'tm'].sendPhone}
                        leftOnClick={() => onChangeStep(1)}
                        leftDisabled={false}
                        rightOnClick={() => onChangeStep(2)}
                        rightDisabled={
                            !identified
                        }
                    />
                </>}

                {step === 2 && <>
                    <div
                        className={style.smallFormContainer}
                    >
                        <div
                            className={style.titleContainer}
                        >
                            <h1
                                className={style.title}
                                style={{
                                    color: Colors[theme ?? 'light'].text
                                }}
                            >
                                <i className={"fas fa-envelope"}></i> {Strings[language ?? 'tm'].otpPlace}
                            </h1>
                        </div>
                        <div
                            className={style.form}
                        >
                            <SendCodeForm
                                initialValues={trashDataInitialValues}
                                validate={trashDataValidate}
                                onSubmit={trashDataOnSubmit}
                            />
                        </div>
                    </div>
                    <PrevNextChanger
                        title={Strings[language ?? 'tm'].confirmPhone}
                        leftOnClick={() => {
                            onChangeStep(1)
                            dispatch(setIdentified(false))
                        }}
                        leftDisabled={false}
                        rightOnClick={() => onChangeStep(2)}
                        rightDisabled={true}
                    />
                </>}
            </div>
        </div>
    )
}

export default Trash